import {makeAutoObservable, observable} from "mobx";
import {injectable} from "inversify";

export interface ISnackBarContent {
	message: string;
	callback?: () => void;
}

export interface ISnackbarStore {
	get content(): ISnackBarContent | null;
	hideSnackBar: () => void;
	openSnackBar: (content: ISnackBarContent) => void;
}

@injectable()
export class SnackbarStore implements ISnackbarStore {
	@observable _snackBarContent: ISnackBarContent | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	get content() {
		return this._snackBarContent;
	}

	hideSnackBar = () => {
		this._snackBarContent = null;
	};

	openSnackBar = (content: ISnackBarContent) => {
		this._snackBarContent = content;
	};
}
